<template>
  <b-card title="PNR Status">
    <b-row class="mb-1">
      <!-- search input -->
      <b-col>
        <section>
          <b-button v-b-modal.modal-1 variant="outline-primary" class="d-flex">
            <feather-icon icon="FilterIcon" />Filter
          </b-button>
        </section>
      </b-col>
    </b-row>
    <b-row v-if="rows">
      <b-col md="12">
        Customer order Code: <b>{{ rows.orderId }}</b>
      </b-col>
      <b-col md="12">
        Order ID/Refund Reference Code:
        <b>{{ rows.traceNumber }}</b>
      </b-col>
      <b-col md="12">
        Amount: <b>{{ rows.amount }}</b>
      </b-col>
      <b-col md="12">
        currency:
        <b>{{ rows.currency }}</b>
      </b-col>
      <b-col md="12">
        Transaction reference:
        <b>{{ rows.transactionReference }}</b>
      </b-col>
      <b-col md="12">
        Transaction Date:
        <b>{{ rows.transactionDate }}</b>
      </b-col>
      <b-col md="12">
        Payment Status: <b>{{ rows.paymentStatus }}</b>
      </b-col>
    </b-row>

    <!-- <b-row v-for="(item, index) in pnrStatus" :key="index">
        <b-col md="3" sm="4">
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-avatar size="48" variant="light-success">
                <feather-icon size="24" icon="TrendingUpIcon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <b-button class="font-weight-bolder mb-0">
                {{ pnr }}
              </b-button>
              <b-card-text class="font-small-3 mb-2">
                Net Collection
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col md="3" sm="4">
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-avatar size="48" variant="light-info">
                <feather-icon size="24" icon="TrendingUpIcon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <b-button class="font-weight-bolder mb-0">
                {{ item.orderId }}
              </b-button>
              <b-card-text class="font-small-3 mb-2">
                Total Collection
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col md="3" sm="4">
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-avatar size="48" variant="light-warning">
                <feather-icon size="24" icon="TrendingUpIcon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <b-button class="font-weight-bolder mb-0">
                {{ item.pnrstatus }}
              </b-button>
              <b-card-text class="font-small-3 mb-2">
                Commission Fee
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row> -->
    <b-modal
      id="modal-1"
      title="Search for PNR"
      ref="modal"
      ok-only
      @ok="handleOk"
    >
      <validation-observer ref="simpleRules">
        <form ref="form">
          <b-row>
            <b-col cols="8" class="m-auto">
              <b-form-group label="Payment option" label-for="payment-option">
                <validation-provider
                  #default="{ errors }"
                  name="Payment option"
                  rules="required"
                >
                  <b-form-select
                    id="merchantId"
                    v-model="filterFopId"
                    :options="paymentOptions"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Transaction Reference" label-for="pnr-input">
                <validation-provider
                  #default="{ errors }"
                  name="Transaction Reference"
                  rules="required"
                >
                  <b-form-input
                    id="transactionID-input"
                    v-model="SearchedTransactionID"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </form>
      </validation-observer>
    </b-modal>

    <b-overlay :show="isLoading" no-wrap />
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BRow,
  BCol,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BButton,
  BFormSelect,
  BPagination,
  BOverlay,
  BModal,
  BFormGroup,
  BFormInput,
  BTab,
  BTabs,
  BLink,
} from "bootstrap-vue";
import axios from "@axios";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BButton,
    VueGoodTable,
    BFormSelect,
    BPagination,
    BOverlay,
    BModal,
    BFormInput,
    BFormGroup,
    BTab,
    BTabs,
    BLink,
    ValidationProvider,
    ValidationObserver,
    required,
  },
  props: {},
  data() {
    return {
      SearchedPNR: "",
      rows: [],
      pnr: "",
      pageLength: 5,
      isLoading: false,
      SearchedTransactionID: "",
      filterFopId: 0,
      paymentOptions: [{ value: 0, text: "--select Payment Option--" }],
      columns: [
        {
          label: "Customer order Code",
          field: "orderId",
        },
        {
          label: "Order ID/Refund Reference Code",
          field: "traceNumber",
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Currency",
          field: "currency",
        },
        {
          label: "Transaction reference",
          field: "transactionReference",
        },
        {
          label: "Transaction Date",
          field: "transactionDate",
        },
        {
          label: "Payment Status",
          field: "paymentStatus",
        },
      ],
    };
  },
  created() {
    this.fetchallPaymentOptions();
  },
  methods: {
    fetchallPaymentOptions() {
      this.isLoading = true;
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/ViewMerchantPaymentOptions"
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.paymentOptions.push({
              value: item.id,
              text: item.name,
            });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          this.filterPNR();
        }
      });
    },
    // filterPNR() {
    //   const valid = this.$refs.form.checkValidity();
    //   if (this.$refs.form.checkValidity()) {
    //     this.$nextTick(() => {
    //       this.$bvModal.hide("modal-1");
    //     });
    //     this.isLoading = true;
    //     this.$store.dispatch("config/getActionPrivilege", "PNR_Status-View");

    //     const specificPNRRequest = axios.get(
    //       `/Order/api/V1.0/Orders/FilterSpecificPNR?OrderIdd=${this.SearchedPNR}`
    //     );

    //     const refundStatusRequest = axios.get(
    //       `/Order/api/V1.0/Orders/FilterPNRRefundStatus?OrderIdd=${this.SearchedPNR}`
    //     );

    //     Promise.all([specificPNRRequest, refundStatusRequest])
    //       .then(([specificPNRResponse, refundStatusResponse]) => {
    //         // Assuming you want to merge the rows from both responses
    //         console.log(specificPNRResponse);
    //         this.pnr = specificPNRResponse.searchedPNR;
    //         this.rows = [
    //           ...specificPNRResponse.pnrResponse,
    //           ...refundStatusResponse.pnrResponse,
    //         ];
    //         this.isLoading = false;
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //         this.isLoading = false;
    //         this.$toast({
    //           component: ToastificationContent,
    //           position: "top-right",
    //           props: {
    //             title: "Error",
    //             icon: "BellIcon",
    //             variant: "danger",
    //             text: `${err.data.message}`,
    //           },
    //         });
    //       });
    //   }
    // },
    async filterPNR() {
      if (this.$refs.form.checkValidity()) {
        this.$nextTick(() => {
          this.$bvModal.hide("modal-1");
        });

        try {
          // Define the API requests using axios
          this.$nextTick(() => {
            this.$bvModal.hide("modal-1");
          });
          this.isLoading = true;
          this.rows = [];
          const getTransactionInfo = axios.get(
            `/Order/api/V1.0/Orders/GetTransactionInfo?referenceNumber=${this.SearchedTransactionID}&paymentOptionId=${this.filterFopId}`
          );
          // Use Promise.allSettled to handle both requests
          const results = await getTransactionInfo;
          this.rows = results;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${error.data.message}`,
            },
          });
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
